import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function Refund() {
  return (
    <LegalPage title="Refund & Cancellation Policy" lastUpdated="June 12, 2026">
      <p>
        This Refund &amp; Cancellation Policy explains how KELTA — Kerala Local Body
        Technical Assistants Association ("KELTA", "we", "us") handles refunds for the
        payments collected through <strong>kelta.co.in</strong> via Razorpay.
      </p>

      <h2>1. Types of Payments</h2>
      <ul>
        <li><strong>Membership fee</strong> — annual subscription paid by new and renewing members.</li>
        <li><strong>Event registration fee</strong> — fee paid to attend a KELTA training, workshop or conference.</li>
        <li><strong>Donations</strong> — voluntary contributions to the association.</li>
      </ul>

      <h2>2. Membership Fee — Refund Rules</h2>
      <p>
        Membership fees are intended to support the year-long activities, welfare
        initiatives and administrative work of the association. The following rules apply:
      </p>
      <ul>
        <li>
          <strong>If your membership is rejected by the admin</strong> (e.g., eligibility
          could not be verified), the full membership fee will be refunded to the
          original payment instrument within <strong>7 working days</strong>.
        </li>
        <li>
          <strong>If you withdraw within 7 days of payment</strong>, and your membership
          has not yet been activated, you may request a refund by writing to
          <a href="mailto:keltastate@gmail.com"> keltastate@gmail.com</a>. The refund
          (less any payment-gateway charges levied by Razorpay) will be processed
          within 7 working days.
        </li>
        <li>
          <strong>If your membership has been activated</strong>, the fee is generally
          non-refundable, as benefits (digital ID, directory listing, event eligibility,
          welfare schemes) become available immediately upon activation.
        </li>
      </ul>

      <h2>3. Event Registration — Refund Rules</h2>
      <ul>
        <li>
          <strong>Cancellation by KELTA</strong> — if an event is cancelled or
          rescheduled by KELTA, registered participants will receive a full refund of
          the registration fee.
        </li>
        <li>
          <strong>Cancellation by participant</strong> — participants may request a
          refund by writing to <a href="mailto:keltastate@gmail.com">keltastate@gmail.com</a>
          at least <strong>5 days before the event date</strong>. Eligible refunds will
          be processed within 7 working days.
        </li>
        <li>
          Cancellation requests made less than 5 days before the event are not
          eligible for refund as seats and arrangements have been committed.
        </li>
      </ul>

      <h2>4. Donations</h2>
      <p>
        Donations made to KELTA are voluntary and are generally non-refundable. In
        exceptional cases (for example, a duplicate transaction or an obvious data
        entry error), please contact us within 7 days of the transaction.
      </p>

      <h2>5. How to Request a Refund</h2>
      <p>To request a refund, send an email to <strong>keltastate@gmail.com</strong> with:</p>
      <ol>
        <li>Your full name and membership ID (if available).</li>
        <li>Email and mobile number used at the time of payment.</li>
        <li>Razorpay transaction ID and date.</li>
        <li>Amount and purpose of payment.</li>
        <li>Reason for the refund request.</li>
      </ol>

      <h2>6. Processing Time</h2>
      <p>
        Approved refunds are initiated by KELTA and processed by Razorpay back to the
        original payment instrument. Depending on your bank or card issuer, the amount
        may take an additional <strong>5–10 working days</strong> to reflect in your
        account.
      </p>

      <h2>7. Payment Gateway Charges</h2>
      <p>
        Razorpay levies a non-refundable transaction fee on every successful payment.
        Where applicable, this fee will be deducted from the refund amount.
      </p>

      <h2>8. Failed or Duplicate Transactions</h2>
      <p>
        If money is debited from your account but your membership / event registration
        is not reflected, please wait up to 24 hours for Razorpay's automatic
        reconciliation. If the amount is still not refunded automatically, write to us
        with the transaction details and we will assist.
      </p>

      <h2>9. Contact</h2>
      <p>
        KELTA — Kerala Local Body Technical Assistants Association<br />
        KELTA Office, M.P Building, 12/79 D,<br />
        Vellalassery P.O, N.I.T Via,<br />
        Kozhikode – 673601<br />
        Email: <a href="mailto:keltastate@gmail.com">keltastate@gmail.com</a>
      </p>
    </LegalPage>
  );
}
